import useDialog from './useDialog'
import { ICreateRideProps } from '../components/dialogs/CreateRide/CreateRideDialog'

const useCreateRideDialog = () => useDialog<ICreateRideProps>('create-ride')

export default useCreateRideDialog
